import LoginCallback from "./LoginCallback";

export default LoginCallback;
